import React, { useEffect, useState } from "react";
import "./editUser.scss";

import VoidSpace from "../../components/voidSpace/VoidSpace";
import HeaderBar from "../../components/headerBar/HeaderBar";
import ListEventType from "../../components/listEventType/ListEventType";

import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import { gestioneSnackbar } from "../../utils/common";
import { Form, Button, Image } from "react-bootstrap";
import { t } from "i18next";
import { getEventTypeWS, getInfoUserWS, updateUserWS } from "./api/editUserApi";
import {
  base64ToBlob,
  isEmpty,
  isValidDate,
  isValidPhoneNumber,
} from "../../utils/validation";

const EditUser = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [phone, setPhone] = useState("");
  const [image, setImage] = useState(null);
  const [file, setFile] = useState(null);

  const [preferences, setPreferences] = useState([]);
  const [listPreferences, setListPreferences] = useState([]);

  useEffect(() => {
    getInfoUserWS()
      .then((res) => {
        setName(res.name);
        setSurname(res.surname);
        setBirthDate(moment(res.birth_date).format("YYYY-MM-DD"));
        setPhone(res.tel);
        setImage(
          res.image_profile
            ? "data:" + res.image_type + ";base64," + res.image_profile
            : null
        );
        setPreferences(res.preferences.map((item) => item.id));
      })
      .catch((err) => gestioneSnackbar(true, err.title, "error"));

    getEventTypeWS()
      .then((res) => setListPreferences(res))
      .catch((err) => console.error(err));
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        setFile(file);
        setImage(URL.createObjectURL(file));
      } else {
        gestioneSnackbar(true, t("validation.only_one_image"), "error");
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEmpty(name)) {
      gestioneSnackbar(true, t("edit_user.void_name"), "error");
      return;
    }

    if (isEmpty(surname)) {
      gestioneSnackbar(true, t("edit_user.void_surname"), "error");
      return;
    }

    if (!isValidPhoneNumber(phone)) {
      gestioneSnackbar(true, t("edit_user.void_phone"), "error");
      return;
    }

    if (!isValidDate(birthDate)) {
      gestioneSnackbar(true, t("edit_user.void_birth_date"), "error");
      return;
    }

    const formData = new FormData();
    if (file) {
      formData.append("profile_image", file); // Selezionato dall'utente
    } else if (image && image.startsWith("data:image")) {
      const blob = base64ToBlob(image);
      formData.append("profile_image", blob, "image.png"); // Convertito da base64
    }

    formData.append("name", name);
    formData.append("surname", surname);
    formData.append("tel", phone);
    formData.append("birth_date", birthDate);
    formData.append("preferences", preferences.toString());

    updateUserWS({ formData })
      .then((res) => {
        console.log(res);
        localStorage.setItem("name", res.info.name);
        localStorage.setItem("surname", res.info.surname);
        if (!isEmpty(res.info.image))
          localStorage.setItem(
            "imageProfile",
            "data:" + res.info.image_type + ";base64," + res.info.image
          );

        gestioneSnackbar(true, res.message, "success");
        URL.revokeObjectURL(image);
        navigate("/settings", { replace: true });
      })
      .catch((err) => gestioneSnackbar(true, err.message, "error"));
  };

  return (
    <>
      <HeaderBar title={t("edit_user.title")} back={true} />
      <Form onSubmit={(e) => handleSubmit(e)}>
        <div className="edit-user-container container-responsive ">
          <div className="input-container">
            <Form.Group className="mb-2" controlId="name">
              <Form.Label>{t("common.name")}</Form.Label>
              <Form.Control
                type="text"
                maxLength={25}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="input-container">
            <Form.Group className="mb-2" controlId="surname">
              <Form.Label>{t("common.surname")}</Form.Label>
              <Form.Control
                type="text"
                maxLength={25}
                value={surname}
                onChange={(e) => setSurname(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="input-container">
            <Form.Group controlId="phoneNumber">
              <Form.Label>{t("common.phone_number")}</Form.Label>
              <Form.Control
                type="tel"
                value={phone}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/\D/g, "");
                  setPhone(onlyNumbers);
                }}
                maxLength={10}
              />
            </Form.Group>
          </div>
          <div className="input-container">
            <Form.Group className="mb-2" controlId="birthdate">
              <Form.Label>{t("common.birth_date")}</Form.Label>
              <Form.Control
                type="date"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
              />
            </Form.Group>
          </div>

          <div className="input-container">
            <Form.Group controlId="imageUpload">
              <Form.Label>{t("edit_user.select_image")}</Form.Label>
              <Form.Control
                type="file"
                accept="image/*" // Limita solo ai file di tipo immagine
                onChange={handleImageChange}
              />
            </Form.Group>
            {image && (
              <div className="selected mt-3">
                <Image
                  src={image}
                  alt="preview"
                  thumbnail
                  style={{ maxWidth: "200px" }}
                />
              </div>
            )}
          </div>

          <ListEventType
            title={t("edit_user.select_your_preference")}
            selected={preferences}
            setSelected={setPreferences}
            data={listPreferences}
            disabled={false}
            max={6}
          />

          <div className="button-container">
            <Button variant="success" type="submit">
              {t("common.save")}
            </Button>
          </div>
        </div>
      </Form>
      <VoidSpace />
    </>
  );
};

export default EditUser;
